import styled from 'styled-components';

export default function InfoPanel() {
  return (
    <Root>
      <li>
        1、Major Compaction，由minorCompactionThreshold=0.2 和 minorCompactionInterval=3600
        进行控制。
        <br />
        每3600秒触发一次，如果 entryLogFile 的有效数据占比少于 20%，则触发清理流程。
      </li>
      <li>
        2、Major Compaction ，由majorCompactionThreshold=0.5 和 majorCompactionInterval=86400
        进行控制。
        <br />
        每86400分钟触发一次，如果 entryLogFile 的有效数据占比少于 50%，则触发清理流程。
      </li>
      <li>3、收到执行GC清理可触发清理流程。</li>
      <LeftBar />
      <Icon style={{ top: 0 }} src={require('./images/top.png')} />
      <Icon style={{ bottom: 0 }} src={require('./images/bottom.png')} />
    </Root>
  );
}

const Root = styled.div`
  position: relative;
  font-size: 14px;
  line-height: 20px;
  color: #202b40;
  padding: 6px 16px;
  background: rgba(244, 157, 11, 0.06);
  border-radius: 7px 6px 6px 7px;
  margin-bottom: 20px;
  li {
    margin: 6px 0;
  }
`;

const LeftBar = styled.div`
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 4px;
  background-color: #f49d0b;
  z-index: 1;
`;

const Icon = styled.img`
  position: absolute;
  left: 0;
  width: 7px;
  height: 10px;
  z-index: 1;
`;
